/* Legacy #/d/<dept> routes (the old category-tile page) redirect to the
   #/c/<dept> family grid.

   Also re-applies the rail selection for a short window after each hash change.
   The SPA rebuilds the rail as part of routing, and home-families' own
   preselectFromUrl() is one-shot per slug (guarded by LAST_PRESEL), so after a
   rebuild the department would otherwise come up unselected and unfocused.
   The window is bounded so it never fights a user's own rail clicks. */
(function () {
  "use strict";

  var RESYNC_MS = [0, 60, 150, 350, 700, 1200];

  function deptSlug(hash) {
    var m = /^#\/d\/([^\/?]+)/.exec(hash || "");
    return m ? m[1] : null;
  }

  function catSlug(hash) {
    var m = /^#\/c\/([^\/?]+)/.exec(hash || "");
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function reroute() {
    var slug = deptSlug(location.hash);
    if (slug) location.replace("#/c/" + slug);
  }

  function homeRail() {
    var rails = document.querySelectorAll("#fv3-app nav.fv3-rail");
    for (var i = 0; i < rails.length; i++) {
      if (rails[i].closest(".fv3-sorter") && document.querySelector(".fv3-dept-block")) return rails[i];
    }
    return null;
  }

  function deptButtons(rail) {
    var out = [], btns = rail.querySelectorAll("button");
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].classList.contains("fv3-rail-new")) out.push(btns[i]);
    }
    return out;
  }

  function deptSlugs() {
    var out = [], blocks = document.querySelectorAll('#fv3-app section.fv3-dept-block[id^="fv3-dept-"]');
    for (var i = 0; i < blocks.length; i++) {
      var id = blocks[i].id.replace(/^fv3-dept-/, "");
      if (id !== "new-products") out.push(id);
    }
    return out;
  }

  function applySelection() {
    var slug = catSlug(location.hash);
    if (!slug) return;
    var rail = homeRail();
    if (!rail) return;
    var btns = deptButtons(rail), idx = deptSlugs().indexOf(slug);
    if (idx < 0 || !btns[idx]) return;
    if (btns[idx].getAttribute("aria-current") === "true") return;
    for (var i = 0; i < btns.length; i++) btns[i].removeAttribute("aria-current");
    btns[idx].setAttribute("aria-current", "true");
  }

  function resync() {
    for (var i = 0; i < RESYNC_MS.length; i++) setTimeout(applySelection, RESYNC_MS[i]);
  }

  window.addEventListener("hashchange", function () { reroute(); resync(); });
  reroute();
  resync();
})();
